<div id="login" class="inner-scroll box" fxLayout="row" fxLayoutAlign="start">
    <div id="login-form-wrapper" fxFlex="30" fusePerfectScrollbar
        [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }" class="">
        <div class="logo-container"
            style="display: flex !important; padding: 50px; width: 100%; padding-bottom: 0px; justify-content: center;">
            <img style="max-width: 200px;" class="C_logo"
                src="../../../../assets/images/logos/logo_ezycharge_main.png" />
        </div>
        <div id="login-form">
            <div class="title">Login To Your Account</div>
            <form name="loginForm" [formGroup]="loginForm" style="padding-top: 21.5px !important" novalidate>
                <mat-form-field appearance="outline" class="form_border">
                    <mat-label style="color: rgba(51, 51, 51, 1) !important">Username</mat-label>
                    <input matInput formControlName="user_name" style="color: rgb(6, 6, 6) !important"
                        style="text-transform: none" />
                    <mat-icon matSuffix style="color: rgba(51, 51, 51, 1) !important"
                        class="secondary-text">account_circle
                    </mat-icon>
                    <!-- <mat-error *ngIf="loginForm.get('user_name').hasError('required')">
                        user name is required
                    </mat-error> -->
                    <mat-error *ngIf="loginForm.get('user_name').invalid">Please enter user name
                    </mat-error>
                    <!-- <div *ngIf="loginForm.get('user_name').hasError('maxlength')">
                        User name not be too long more then 50 character.
                   </div>  -->
                </mat-form-field>

                <mat-form-field appearance="outline" class="form_border">
                    <mat-label>Password</mat-label>
                    <input matInput [type]="isPasswordFieldType ? 'text' : 'password'" formControlName="password"
                        style="color: rgb(6, 6, 6) !important" style="text-transform: none" />
                    <mat-icon (click)="togglePasswordFieldType()" matSuffix
                        style="color: rgba(51, 51, 51, 1) !important" matTooltip="Please enter confirm password">{{
                        isPasswordFieldType
                        ? "visibility_off"
                        : "visibility"
                        }}</mat-icon>
                    <!-- <mat-error  *ngIf="loginForm.get('password').hasError('required')">
                        Password is required
                    </mat-error> -->
                    <mat-error *ngIf="loginForm.get('password').invalid">password length must be more then 6 character
                    </mat-error>
                    <!-- <mat-error *ngIf="loginForm.get('password').hasError('minLength')">
                            User name not be too long more then 50 character.
                    </mat-error>  -->
                </mat-form-field>

                <button class="loginbtn" mat-raised-button color="accent" style="margin-top: 5px !important"
                    class="submit-button login_button" style="font-size: larger;" aria-label="LOG IN"
                    [disabled]="loginForm.invalid" (click)="login()">
                    Login
                </button>
                <div class="remember-forgot-password" *ngIf="isSuccessMessage" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <mat-error style="color: rgba(51, 51, 51, 1)">
                        <b> {{ successMessage }}</b></mat-error>
                </div>
                <div class="remember-forgot-password" *ngIf="isErrorMessage" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <mat-error>
                        <b> {{ errorMessage }}</b></mat-error>
                </div>
                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end end">
                    <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                        Remember Me
                    </mat-checkbox> -->

                    <a class="forgot-password" [routerLink]="'/forgotpassword'">
                        Forgot Password?
                    </a>
                    <a class="forgot-password" [routerLink]="'/register'">
                        &nbsp; |&nbsp; Register
                    </a>
                </div>
            </form>

            <div class="forgot-password" fxLayout="column" style="position: absolute; bottom: 10px; color: #ffffff">
                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto" name="form"
                    style="margin-bottom: 10px">
                    <div fxFlex="100">
                        <a href="https://ezy-charge.com/about-us.php" style="font-size: 0.8em" target="_blank"
                            style="color: #00796a;">About Us</a>&nbsp;&nbsp;
                        <a href="https://ezy-charge.com/contact.php" style="padding-left: 5px; font-size: 0.8em"
                            target="_blank" style="color: #00796a;">Contact Us</a>&nbsp;&nbsp;
                        <a href="https://ezy-charge.com/privacy-policy.php" style="padding-left: 5px; font-size: 0.8em"
                            target="_blank" style="color: #00796a;">Privacy & Policy</a>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto" name="form"
                    style="margin-bottom: 10px">
                    <div fxFlex="100">
                        <!-- <a href="#"
                            style="padding-bottom:5px;font-size:  0.8em;" target="_blank">Product
                            Services</a>&nbsp;&nbsp; -->
                        <a href="https://ezy-charge.com/refund-cancellation-policy.php"
                            style="padding-left: 5px; font-size: 0.8em" target="_blank" style="color: #00796a;">Refund &
                            Cancellation Policy</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="v-line"></div>

    <div id="login-intro" fxFlex="70" fxFlex fxHide fxShow.gt-xs>
        <!-- 
        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos/logo_ezycharge_main.png">
        </div> -->
        <div style="display: flex; align-items: center;">
            <div class="heading1">Welcome to </div>
            <div class="logo-container" style="width: 100px;">
                <img class="C_logo" src="../../../../assets/images/logos/logo_ezycharge_main.png" />
            </div>
        </div>
        <div class="paragraph1">
            We are powering next generation mobility by delivering innovative EV
            charging infrastructure and Li-ion batteries for all segments of
            vehicles.
        </div>
        <div class="img-container">
            <img class="img1" src="../../../../assets/images/loginpage/Group 331.png" />
        </div>
        <p class="version" style="color: rgba(149, 164, 150, 1)">
            Powered By Ezy Charge
        </p>

        <!-- <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            The electric vehicle (EV) revolution is here, and businesses in the EV landscape must embrace cutting-edge solutions to thrive. SparkDrive delves into the importance of EV Charging Management Solutions (EV CMS) and their pivotal role in driving operational efficiency, enhancing customer experience, unlocking new revenue streams, and future proofing businesses in the dynamic EV market.
            To navigate this electrifying journey successfully, however, SparkEV (An enterprise EV Charging Application) play a crucial roles for CPOs and EV charging station at the heart of their operations.
        </div> -->
    </div>
</div>